<div [innerHtml]="content"></div>
